import React from "react";
import Modal from "../../../../components/Common/Modal/Modal";
import classes from "./WorkOfficeLocationModal.module.scss";
import TabLinks from "../../../../components/Common/TabLinks/TabLinks";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import {
  getCityListActionHandler,
  getCountryListActionHandler,
  getStateListActionHandler,
  getWorkOfficeListActionHandler,
} from "../../../../store/actions/actionHandlers/reportActionHandler";
import {
  getCityListAction,
  getCountryListAction,
  getStateListAction,
  getWorkOfficeListAction,
} from "../../../../store/actions/actionCreators/reportActionCreator";
import getWorkOfficeList from "../../../../api/reports/tabularReport/getWorkOfficeList";
import Button from "../../../../components/Common/Button/Button";

const WorkOfficeLocationModal = ({
  show,
  setShow,
  setSelectedLocationValue,
  // setSelectedLocationId,
  setCountryId,
  setStateId,
  setCityId,
  setWorkOfficeId,
}) => {
  const [activeTab, setactiveTab] = useState(1);
  const dispatch = useDispatch();
  const reportState = useSelector((state) => state.reportReducer);
  const { countryList, stateList, cityList, workOfficeList } = reportState;
  const [selectedData, setSelectedData] = useState([]);
  // const [countryData, setCountryData] = useState(null);
  // const [stateData, setStateData] = useState(null);
  // const [cityData, setCityData] = useState(null);
  // const [workOfficeData, setWorkOfficeData] = useState(null);
  // const [countryId, setCountryId] = useState(0);
  // const [stateId, setStateId] = useState(0);
  // const [cityId, setCityId] = useState(0);
  // const [workOfficeId, setWorkOfficeId] = useState(0);

  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [workOffice, setWorkOffice] = useState("");

  const [inputData, setInputData] = useState(null);

  const handleRadio = (data) => {
    const updatedData = inputData?.map((item) => {
      if (activeTab === 1 && item?.Id === data?.Id) {
        dispatch(getStateListActionHandler(data?.Id));
        setCountryId(data?.Id);
        setCountry(data?.CountryName);
        return { ...item, isChecked: data?.isChecked ? false : true };
      }

      if (activeTab === 2 && item?.Id === data?.Id) {
        dispatch(getCityListActionHandler(data?.Id));
        setStateId(data?.Id);
        setState(data?.StateName);
        return { ...item, isChecked: data?.isChecked ? false : true };
      }
      if (activeTab === 3 && item?.Id === data?.Id) {
        dispatch(getWorkOfficeListActionHandler(data?.Id));
        setCityId(data?.Id);
        setCity(data?.CityName);
        return { ...item, isChecked: data?.isChecked ? false : true };
      }
      if (activeTab === 4 && item?.StoreId === data?.StoreId) {
        setWorkOfficeId(data?.StoreId);
        setWorkOffice(data?.StoreName);
        return { ...item, isChecked: data?.isChecked ? false : true };
      } else return item;
    });
    setInputData(updatedData);
    if (activeTab === 1) dispatch(getCountryListAction(updatedData));
    if (activeTab === 2) dispatch(getStateListAction(updatedData));
    if (activeTab === 3) dispatch(getCityListAction(updatedData));
    if (activeTab === 4) dispatch(getWorkOfficeListAction(updatedData));
    // console.log(updatedData);
  };

  useEffect(() => {
    dispatch(getCountryListActionHandler());
  }, [dispatch]);

  useEffect(() => {
    if (activeTab === 1 && countryList) {
      setInputData(countryList);
    }
    if (activeTab === 2 && stateList) {
      setInputData(stateList);
    }
    if (activeTab === 3 && cityList) {
      setInputData(cityList);
    }
    if (activeTab === 4 && workOfficeList) {
      setInputData(workOfficeList);
    }
  }, [
    countryList,
    stateList,
    cityList,
    workOfficeList,
    activeTab,
    setInputData,
  ]);

  let contentTabs = [
    {
      id: 1,
      name: "Region/Country",
      heading: "Region/Country",
    },
    {
      id: 2,
      name: "State/Provience",
      heading: "State/Provience",
    },
    {
      id: 3,
      name: "City",
      heading: "City",
    },
    {
      id: 4,
      name: "Work/Office Location",
      heading: "Work/Office Location",
    },
  ];

  const handleApply = () => {
    setShow(false);
    // setSelectedValue(country + "; " + state + "; " + city + "; " + workOffice);
    setSelectedLocationValue(country + state + city + workOffice);
  };

  return (
    <Modal
      isOpen={show}
      width={"90"}
      toggle={() => {
        setShow(false);
      }}
      heading={"Work Office Location"}
    >
      <div className={classes.distributePoll}>
        <div className={classes.usersTable}>
          <TabLinks
            tabs={contentTabs}
            activeTab={activeTab}
            setActiveTab={setactiveTab}
          />
          <div className={classes.tabContent}>
            <div className={classes.pollUsers}>
              <div className={classes.pollUsersList}>
                {inputData?.map((data, index) => {
                  return (
                    <div key={index}>
                      <div className={classes.border}></div>
                      <div className={classes.pollUser}>
                        <div className={classes.pollUserItem}>
                          <p>
                            {activeTab === 1 && data?.CountryName}
                            {activeTab === 2 && data?.StateName}
                            {activeTab === 3 && data?.CityName}
                            {activeTab === 4 && data?.StoreName}
                            {/* {activeTab === 3 &&
                              data?.type === "User" &&
                              data?.FirstName + "(" + data?.LoginId + ")"}
                            {activeTab === 3 &&
                              data?.type === "User Group" &&
                              data?.Name} */}
                          </p>
                          {/* {((activeTab === 1 && data?.LoginId) ||
                            (activeTab === 2 && data?.UserGroupId)) && ( */}
                          <input
                            className={classes.userCheckbox}
                            name="countryRadio"
                            type="radio"
                            checked={data?.isChecked}
                            onChange={() => handleRadio(data)}
                          />
                          {/* )} */}
                          {/* {activeTab === 3 && <p>{data?.type}</p>} */}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className={classes.apply}>
            <Button label="Apply" dark small onClick={handleApply} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default WorkOfficeLocationModal;
